"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsAfterConstraint = exports.IsAfter = void 0;
const class_validator_1 = require("class-validator");
function IsAfter(property, validationOptions) {
    return (object, propertyName) => {
        (0, class_validator_1.registerDecorator)({
            target: object.constructor,
            propertyName,
            options: validationOptions,
            constraints: [property, validationOptions],
            validator: IsAfterConstraint
        });
    };
}
exports.IsAfter = IsAfter;
let IsAfterConstraint = class IsAfterConstraint {
    validate(value, args) {
        const relatedPropertyName = args.constraints[0];
        const relatedValue = args.object[relatedPropertyName];
        const endDate = new Date(value);
        const startDate = new Date(relatedValue);
        return endDate > startDate;
    }
    defaultMessage(args) {
        const options = args.constraints[1];
        return options.message || 'End date must be after start date';
    }
};
exports.IsAfterConstraint = IsAfterConstraint;
exports.IsAfterConstraint = IsAfterConstraint = __decorate([
    (0, class_validator_1.ValidatorConstraint)({ name: 'IsAfter' })
], IsAfterConstraint);
